module.exports = __webpack_public_path__ + "static/media/RunNUS_Logo_No_Year.520a83a2.jpg";